import { el, mount, unmount, setAttr } from 'redom';

import application from 'application';

import { stringToSVG } from 'utilities';
import {
  displayElementAroundAnchor
} from 'utilities/element-position';

import mediaProviderTypes from 'constants/media-provider-types';

import FloatedInput from '../floated-input';
import StockImagesPanel from './stock-images-panel';

import './index.scss';

import urlIconString from 'assets/images/link-toggle-icon.svg?raw';
import mediaUploadIconString from 'assets/images/media-upload-icon.svg?raw';
import desktopIconString from 'assets/images/desktop-icon.svg?raw';
import searchIconString from 'assets/images/search-icon.svg?raw';
import askAIIconString from 'assets/images/ask-ai-icon.svg?raw';
import gifIconString from 'assets/images/gif-icon.svg?raw';

const gifIcon = stringToSVG(gifIconString);
const askAIIcon = stringToSVG(askAIIconString);
const searchIcon = stringToSVG(searchIconString);
const desktopIcon = stringToSVG(desktopIconString);
const mediaUploadIcon = stringToSVG(mediaUploadIconString);
const urlIcon = stringToSVG(urlIconString);

class FileSelectorPanelControl {

  constructor(configuration) {

    this.allowGIFs = configuration.allowGIFs;
    this.url = configuration.url;
    this.onURLChange = configuration.onURLChange;
    this.onFile = configuration.onFile;
    this.hideTimeout = null;

    this.fileSelectionOptions = null;
    this.urlInputDisplayControl = null;

    this.renderFileSelectionOptions();
    this.button = el('button.file-selector-panel-control.inline-toolbar-button', {
      type: 'button'
    }, [mediaUploadIcon.cloneNode(true)]);

    this.el = el('.file-selector-panel-control-main', {
      onmouseenter: this.showOptions.bind(this),
      onmouseleave: this.hideOptions.bind(this)
    }, [
      this.button,
      this.fileSelectionOptions
    ]);

  }

  showOptions() {

    if (this.hideTimeout !== null) {
      clearTimeout(this.hideTimeout);
      this.hideTimeout = null;
    }

    setAttr(this.fileSelectionOptions, {
      style: {
        display: 'flex'
      }
    });

    const element = this.fileSelectionOptions;
    const anchorElement = this.el;
    const viewportElement = void 0;
    const verticalOffset = 7;
    const horizontalOffset = 0;
    const startSide = 'top';
    const placeOnCenter = true;
    const positionableSides = ['top', 'bottom'];

    displayElementAroundAnchor(element, anchorElement, viewportElement, verticalOffset, horizontalOffset, startSide, placeOnCenter, positionableSides);

  }

  hideOptions() {

    this.hideTimeout = setTimeout(function delayedHide() {
      setAttr(this.fileSelectionOptions, {
        style: {
          display: 'none'
        }
      });
      this.hideTimeout = null;
    }.bind(this), 350);

  }

  async uploadFile() {

    const response = await application.domUtility.askAnyTypeFile();

    if (response.cancelled === true) {
      return;
    }

    this.onFile(response.file);

  }

  handleUploadControlClick() {

    this.uploadFile();

  }

  handleURLCompletedEvent(url, input) {

    unmount(this.el, input);

    this.onURLChange(url);

  }

  handleURLCancelledEvent(input) {

    unmount(this.el, input);

  }

  displayURLInput() {

    const urlInput = new FloatedInput({
      value: this.url,
      placeholder: 'https://',
      onComplete: this.handleURLCompletedEvent.bind(this),
      onCancel: this.handleURLCancelledEvent.bind(this),
      anchor: this.urlInputDisplayControl,
      viewport: document.body
    });

    mount(this.el, urlInput);

  }

  handleURLInputDisplayControlClick() {

    this.displayURLInput();

  }

  async showSearchPanel() {

    const result = await application.dialogsManager.displayWithHeader(StockImagesPanel, {
      title: 'Search images',
      contentConfiguration: {
        type: mediaProviderTypes.UNSPLASH
      }
    });

    if (result.cancelled === true) {
      return;
    }

    this.onURLChange(result.value.url);

  }

  async showGIFSearchPanel() {

    const result = await application.dialogsManager.displayWithHeader(StockImagesPanel, {
      title: 'Search images',
      contentConfiguration: {
        type: mediaProviderTypes.GIPHY
      }
    });

    if (result.cancelled === true) {
      return;
    }

    this.onURLChange(result.value.url);

  }

  showAIPanel() {

    application.assistantManager.show({
      text: '',
      options: {
        skipTrainingData: true,
        historyLimit: 0
      }
    });

  }

  renderFileSelectionOptions() {

    const buttons = [];

    const uploadButton = el('button.media-upload-control', {
      class: 'inline-toolbar-button',
      onclick: this.handleUploadControlClick.bind(this)
    }, desktopIcon.cloneNode(true));

    this.urlInputDisplayControl = el('button.media-url-input-display-control', {
      class: 'inline-toolbar-button',
      onclick: this.handleURLInputDisplayControlClick.bind(this)
    }, urlIcon.cloneNode(true));

    const searchButton = el('button.media-search-control', {
      class: 'inline-toolbar-button',
      onclick: this.showSearchPanel.bind(this)
    }, searchIcon.cloneNode(true));

    const gifSearchButton = el('button.media-search-control gif-media-search-control', {
      class: 'inline-toolbar-button',
      onclick: this.showGIFSearchPanel.bind(this)
    }, gifIcon.cloneNode(true));

    const generateWithAIButton = el('button.media-ai-control', {
      class: 'inline-toolbar-button',
      onclick: this.showAIPanel.bind(this)
    }, askAIIcon.cloneNode(true));

    buttons.push(el('x-tooltip', {
      text: 'Upload file'
    }, [uploadButton]), el('x-tooltip', {
      text: 'Enter url'
    }, [this.urlInputDisplayControl]), el('x-tooltip', {
      text: 'Search stock image'
    }, [searchButton]));

    if (this.allowGIFs === true) {
      buttons.push(el('x-tooltip', {
        text: 'Search GIF image'
      }, [gifSearchButton]));
    }

    buttons.push(el('x-tooltip', {
      text: 'Generate using AI'
    }, [generateWithAIButton]));

    this.fileSelectionOptions = el('.file-selection-options', buttons);

    return this.fileSelectionOptions;

  }

}

export default FileSelectorPanelControl;